import { makeAutoObservable } from "mobx";

/**
 * Tracks whether a payment, booking, or other critical write is currently
 * in flight anywhere in the app, so the recovery-reload watcher can avoid
 * reloading the page mid-submission. Call begin()/end() in matching pairs
 * (e.g. begin() when a submit handler starts, end() in its finally block).
 */
class CriticalOperationStore {
  count = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get isInProgress() {
    return this.count > 0;
  }

  begin = () => {
    this.count += 1;
  };

  end = () => {
    this.count = Math.max(0, this.count - 1);
  };
}

export default new CriticalOperationStore();
